import { toNumber } from 'lodash'
import { useState } from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { useDispatch } from 'react-redux'
import {
  Box,
  Dialog,
  Pincode,
  Stack,
  Text,
  TextLinkButton,
  useResponsiveValue
} from '@machobear/design-system'

const MAX_ATTEMPTS = 5

const VerifyCodeModal = ({ listingId, history, showModal, open, onClose }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [error, setError] = useState(false)
  const [remaining, setRemaining] = useState()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const isMobile = useResponsiveValue()({
    mobile: true,
    tablet: false
  })

  const handleComplete = value => {
    setIsSubmitting(true)
    onSubmit(value)
  }

  const onSubmit = async value => {
    const { response, body } = await dispatch.listing.submitVerifyCode({
      listingId: toNumber(listingId),
      code: toNumber(value)
    })

    if (!response.ok) {
      const numAttempts = body.attempts_count
      setError(true)

      // numAttempts is undefined if the same code is submitted again right away
      if (numAttempts) {
        setRemaining(MAX_ATTEMPTS - numAttempts)
      }
      if (numAttempts === MAX_ATTEMPTS) {
        onClose()
        showModal('maxAttempts')()
        setError(false)
      }
    } else {
      setError(false)
      onClose()
      showModal('verificationSuccess')()
    }
    setIsSubmitting(false)
  }

  return (
    <Dialog
      id="VerifyCodeModal"
      title={t('l.verify_listing.view.enter_code.title', 'Enter verification code')}
      open={open}
      onClose={onClose}
      width="content"
    >
      <Box style={isMobile ? { maxWidth: '295px' } : { maxWidth: '440px' }}>
        <Stack space="xlarge">
          <Text>
            {t(
              'l.verify_listing.view.enter_code.text',
              'Please enter the 6-digit code we sent via mail to verify your listing.'
            )}
          </Text>
          <Pincode
            length={6}
            pattern="numeric"
            onComplete={value => handleComplete(value)}
            disabled={isSubmitting}
            tone={error ? 'critical' : 'neutral'}
            message={
              error &&
              (remaining > 1 ? (
                <Trans i18nKey="l.verify_listing.view.verify_code_error_multiple.text">
                  Incorrect code. {{ remaining }} attempts left.
                </Trans>
              ) : (
                t(
                  'l.verify_listing.view.verify_code_error_single.text',
                  'Incorrect code. 1 attempt left.'
                )
              ))
            }
          />
          <Text>
            {t('l.verify_listing.view.help.text', 'Need assistance? ')}
            <TextLinkButton onClick={() => history.push('/chat/support-room')}>
              {t('l.verify_listing.view.help.link', 'Contact support.')}
            </TextLinkButton>
          </Text>
        </Stack>
      </Box>
    </Dialog>
  )
}

export default VerifyCodeModal
